import { Toast, ToastProps } from '@trackman/web-shared-components';
import { useStores } from 'index';
import { observer } from 'mobx-react-lite';
import React from 'react';

export const Notifications = observer(() => {
  const { notificationsStore } = useStores();

  return (
    <>
      {notificationsStore.toasts &&
        notificationsStore.toasts.map((toast: ToastProps, index: number) => {
          return (
            <Toast
              onClose={() => notificationsStore.handleOnClose(toast.id ? toast.id : '')}
              key={index}
              severity={toast.severity}
              message={toast.message}
              open
            />
          );
        })}
    </>
  );
});
